<template>
  <b-modal 
    ref="modalCompraVenda" 
    id="modal-configuracao-compravenda" 
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="xl"
    @shown="onModalShown"
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
         style="background: linear-gradient(135deg, #f8b739 0%, #f39c12 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-shopping-cart text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Configurações de Compra e Venda</h5>
        <small class="text-white opacity-75">Defina os parâmetros de faturamento e vendas do sistema</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <!-- Corpo do Modal -->
    <div class="p-4" style="max-height: 70vh; overflow-y: auto;">
      
      <!-- Grupo Parâmetros para Faturamento e Entrada -->
      <div class="modal-section-title mb-3">
        <i class="fa fa-file-text-o mr-2 text-warning"></i> Parâmetros para Faturamento e Entrada
      </div>
      <b-row>
        <b-col md="4">
          <b-form-group label="Tipo de Doc. a Receber" label-for="grupo-fatura">
            <grupo-areceber-drop-down 
              v-model="registro.COD_GRUPOFATURA"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Tipo de Documento a Pagar" label-for="grupo-entrada">
            <grupo-apagar-drop-down 
              v-model="registro.COD_GRUPOENTRADA"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Movimentação Venda Padrão" label-for="tipo-mov-venda">
            <tipo-movimentacao-drop-down 
              v-model="registro.TIPO_MOVIMENTACAO_VENDA_ID"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <b-form-group label="Movimentação Externa" label-for="tipo-mov-externa">
            <tipo-movimentacao-drop-down 
              v-model="registro.TIPO_MOVIMENTACAO_VENDA_EXT_ID"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="CFOP Entrada" label-for="cfop-entrada">
            <cfop-drop-down 
              v-model="registro.COD_CFOPENT"
              :state="null"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Tabela de Preço Preferencial" label-for="tabela-preco">
            <tabela-preco-drop-down 
              v-model="registro.TABELA_PRECO_ID"
              :state="null"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo Linhas para instruções no documento de Venda -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-align-justify mr-2 text-info"></i> Linhas para instruções no documento de Venda
      </div>
      <b-row>
        <b-col md="12">
          <b-form-group label="Linha 1" label-for="linha1">
            <b-form-input
              v-model="registro.LINHA1ROMA"
              maxlength="255"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group label="Linha 2" label-for="linha2">
            <b-form-input
              v-model="registro.LINHA2ROMA"
              maxlength="255"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group label="Linha 3" label-for="linha3">
            <b-form-input
              v-model="registro.LINHA3ROMA"
              maxlength="255"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Grupo de Controles -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-toggle-on mr-2 text-success"></i> Controles
      </div>

      <b-row>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_ESTOQUE_ROMANEIO"
            value="1"
            unchecked-value="0"
          >
            Movimenta Estoque por Entradas e Romaneios
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_ESTOQUE_NFE"
            value="1"
            unchecked-value="0"
          >
            Movimenta Estoque por NFe de Entrada e Saída
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_IMPRIME_VENDA_DIRETO"
            value="1"
            unchecked-value="0"
          >
            Imprime vendas direto na Impressora
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_IMPRIME_LOGO_VENDA"
            value="1"
            unchecked-value="0"
          >
            Imprime Logo no romaneio de Venda
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_PERMITE_INFORMAR_CUSTO_VENDA"
            value="1"
            unchecked-value="0"
          >
            Informar o Custo na Venda
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-group label="Fluxo de Expediçãoo de Vendas" label-for="op-expedicao-direta">
            <b-form-select
              id="op-expedicao-direta"
              v-model="registro.OP_EXPEDICAO_DIRETA"
              :options="opcoesFluxoExpedicao"
              class="rounded-pill shadow-xs"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_PESA_VENDA"
            value="1"
            unchecked-value="0"
          >
            Pesa Produtos na Venda
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_PERMITE_INFORMAR_DATA_VENDA"
            value="1"
            unchecked-value="0"
          >
            Permite informar a data da Venda
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_EXPEDICAO_POR_LOTE"
            value="1"
            unchecked-value="0"
          >
            Expedição por Lote (Rastreabilidade)
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_VENDA_MAPEAR_LOTE"
            value="1"
            unchecked-value="0"
          >
            Mapear Lotes no Pedido de Venda
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_BLOQUEAR_INADIMPLENTE"
            value="1"
            unchecked-value="0"
          >
            Bloquear quando inadimplente
          </b-form-checkbox>
        </b-col>
        <b-col md="6">
          <b-form-checkbox
            v-model="registro.OP_PEDIDO_NUMERO_AUTOMATICO"
            value="1"
            unchecked-value="0"
          >
            Número do Pedido de Venda Automático
          </b-form-checkbox>
        </b-col>
      </b-row>

      <!-- Grupo Calcular custo -->
      <div class="modal-section-title mb-3 mt-4">
        <i class="fa fa-calculator mr-2 text-primary"></i> Calcular Custo e Outras Configurações
      </div>

      <b-row>
        <b-col md="12">
          <b-form-group label="Como calcular o custo do estoque" label-for="calc-custo">
            <b-form-select v-model="registro.OP_COMO_CAL_CUSTO_ESTOQUE">
              <option value="M">M - Média (Calcula o custo do produto pela média de compras)</option>
              <option value="U">U - Última Compra (Calcula pela última compra)</option>
              <option value="D">D - Estudo de Lucro (Última compra, exceto produtos com estudo de lucro)</option>
            </b-form-select>
            <small class="form-text text-muted">
              Para a opção "D - Estudo de Lucro", é necessário informar o cliente da desossa que servirá para calcular os custos do estoque.
            </small>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Como será sugerido os preços dos produtos vendidos" label-for="preco-tabela">
            <b-form-select v-model="registro.OP_VENDA_PRECO_POR_TABELA">
              <option value="L">L - Preços Livres</option>
              <option value="T">T - Preços Tabelados</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Compra de Animais por parcelamento" label-for="compra-gado-parcelado">
            <b-form-select v-model="registro.OP_COMPRA_GADO_PARCELADO">
              <option value="S">S - Sim</option>
              <option value="N">N - Não</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Controle de Estoque por Peças?" label-for="venda-pecas">
            <b-form-select v-model="registro.OP_VENDA_POR_PECAS">
              <option value="S">S - Sim</option>
              <option value="N">N - Não</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Número padrão de vias Impressas no Pedido" label-for="nr-vias">
            <b-form-input
              v-model.number="registro.NR_VIAS_PEDIDO"
              type="number"
              min="1"
              max="10"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Qual o tipo de formulário de Vendas usar" label-for="tipo-form-vendas">
            <b-form-select v-model="registro.OP_TIPO_FORM_VENDAS">
              <option value="P">P - Formulário Produção</option>
              <option value="N">N - Formulário Novo</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Imprime Promissórias" label-for="imprime-promissoria">
            <b-form-select v-model="registro.OP_IMPRIME_PROMISSORIA">
              <option value="S">S - Sim</option>
              <option value="N">N - Não</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Tipo de Formulário Compra Gado" label-for="form-compra-gado">
            <b-form-select v-model="registro.FORMULARIO_COMPRA_GADO">
              <option value="0">0 - Antigo</option>
              <option value="1">1 - Novo</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Máximo de dias para alterar pedido" label-for="dias-alterar">
            <b-form-input
              v-model.number="registro.NR_DIAS_ALTERAR_PEDIDO"
              type="number"
              min="0"
              max="365"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Emitir Pedido Vendas" label-for="imprime-pedido">
            <b-form-select v-model="registro.OP_IMPRIME_PEDIDO_VENDAS">
              <option value="S">S - Sim</option>
              <option value="N">N - Não</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Controla check web de vendas" label-for="check-web">
            <b-form-select v-model="registro.OP_EXIBE_CHECK_VENDA_WEB">
              <option value="S">S - Sim</option>
              <option value="N">N - Não</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

    </div>

    <!-- Rodapé Premium -->
    <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
      <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar()">
        CANCELAR
      </b-button>
      <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="salvar()">
        <i class="fa fa-check-circle mr-1"></i> SALVAR
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import GrupoApagarDropDown from '../views/componentes/dropdown/GrupoApagarDropDown.vue'
import GrupoAreceberDropDown from '../views/componentes/dropdown/GrupoAreceberDropDown.vue'
import TipoMovimentacaoDropDown from '../views/componentes/dropdown/TipoMovimentacaoDropDown.vue'
import CfopDropDown from '../views/componentes/dropdown/CfopDropDown.vue'
import TabelaPrecoDropDown from '../views/componentes/dropdown/TabelaPrecoDropDown.vue'

export default {
  name: 'ModalConfiguracaoCompraVenda',
  components: {
    GrupoApagarDropDown,
    GrupoAreceberDropDown,
    TipoMovimentacaoDropDown,
    CfopDropDown,
    TabelaPrecoDropDown
  },
  data() {
    return {
      opcoesFluxoExpedicao: [
        { value: '0', text: '0 - Fluxo com Ordem de Expedicao' },
        { value: '1', text: '1 - Expedicao Direta' },
        { value: '2', text: '2 - Fluxo com Conferencia' }
      ],
      registro: {
        SEQUENCIA: 1,
        // Parâmetros para Faturamento e Entrada
        COD_GRUPOFATURA: null,
        COD_GRUPOENTRADA: null,
        TIPO_MOVIMENTACAO_VENDA_ID: null,
        COD_CFOPENT: null,
        TABELA_PRECO_ID: null,
        // Linhas instruções
        LINHA1ROMA: '',
        LINHA2ROMA: '',
        LINHA3ROMA: '',
        // Controles (checkboxes)
        OP_ESTOQUE_ROMANEIO: '0',
        OP_ESTOQUE_NFE: '0',
        OP_IMPRIME_VENDA_DIRETO: '0',
        OP_IMPRIME_LOGO_VENDA: '0',
        OP_PERMITE_INFORMAR_CUSTO_VENDA: '0',
        OP_EXPEDICAO_DIRETA: '0',
        OP_PESA_VENDA: '0',
        OP_PERMITE_INFORMAR_DATA_VENDA: '0',
        OP_BLOQUEAR_INADIMPLENTE: '0',
        OP_PEDIDO_NUMERO_AUTOMATICO: '0',
        // Calcular custo e outras configs
        OP_COMO_CAL_CUSTO_ESTOQUE: 'M',
        OP_VENDA_PRECO_POR_TABELA: 'L',
        OP_COMPRA_GADO_PARCELADO: 'N',
        OP_VENDA_POR_PECAS: 'N',
        NR_VIAS_PEDIDO: 1,
        OP_TIPO_FORM_VENDAS: 'N',
        OP_IMPRIME_PROMISSORIA: 'N',
        FORMULARIO_COMPRA_GADO: '1',
        NR_DIAS_ALTERAR_PEDIDO: 0,
        OP_IMPRIME_PEDIDO_VENDAS: 'S',
        OP_EXIBE_CHECK_VENDA_WEB: 'N',
        OP_EXPEDICAO_POR_LOTE: '0',
        OP_VENDA_MAPEAR_LOTE: '0'
      }
    }
  },
  methods: {
    abrir() {
      this.$refs.modalCompraVenda.show()
    },
    fechar() {
      this.$refs.modalCompraVenda.hide()
    },
    async carregarDados() {
      try {
        const { data } = await this.$http.get('/api/protected/parametro/getDados')
        if (data && data.length > 0) {
          this.registro = {
            ...this.registro,
            ...data[0],
            // Garantir valores default para checkboxes
            OP_ESTOQUE_ROMANEIO: data[0].OP_ESTOQUE_ROMANEIO || '0',
            OP_ESTOQUE_NFE: data[0].OP_ESTOQUE_NFE || '0',
            OP_IMPRIME_VENDA_DIRETO: data[0].OP_IMPRIME_VENDA_DIRETO || '0',
            OP_IMPRIME_LOGO_VENDA: data[0].OP_IMPRIME_LOGO_VENDA || '0',
            OP_PERMITE_INFORMAR_CUSTO_VENDA: data[0].OP_PERMITE_INFORMAR_CUSTO_VENDA || '0',
            OP_EXPEDICAO_DIRETA: data[0].OP_EXPEDICAO_DIRETA || '0',
            OP_PESA_VENDA: data[0].OP_PESA_VENDA || '0',
            OP_PERMITE_INFORMAR_DATA_VENDA: data[0].OP_PERMITE_INFORMAR_DATA_VENDA || '0',
            OP_BLOQUEAR_INADIMPLENTE: data[0].OP_BLOQUEAR_INADIMPLENTE || '0',
            OP_PEDIDO_NUMERO_AUTOMATICO: data[0].OP_PEDIDO_NUMERO_AUTOMATICO || '0',
            // Garantir valores default para selects
            OP_COMO_CAL_CUSTO_ESTOQUE: data[0].OP_COMO_CAL_CUSTO_ESTOQUE || 'M',
            OP_VENDA_PRECO_POR_TABELA: data[0].OP_VENDA_PRECO_POR_TABELA || 'L',
            OP_COMPRA_GADO_PARCELADO: data[0].OP_COMPRA_GADO_PARCELADO || 'N',
            OP_VENDA_POR_PECAS: data[0].OP_VENDA_POR_PECAS || 'N',
            NR_VIAS_PEDIDO: data[0].NR_VIAS_PEDIDO || 1,
            OP_TIPO_FORM_VENDAS: data[0].OP_TIPO_FORM_VENDAS || 'N',
            OP_IMPRIME_PROMISSORIA: data[0].OP_IMPRIME_PROMISSORIA || 'N',
            FORMULARIO_COMPRA_GADO: data[0].FORMULARIO_COMPRA_GADO || '1',
            NR_DIAS_ALTERAR_PEDIDO: data[0].NR_DIAS_ALTERAR_PEDIDO || 0,
            OP_IMPRIME_PEDIDO_VENDAS: data[0].OP_IMPRIME_PEDIDO_VENDAS || 'S',
            OP_EXIBE_CHECK_VENDA_WEB: data[0].OP_EXIBE_CHECK_VENDA_WEB || 'N',
            OP_EXPEDICAO_POR_LOTE: data[0].OP_EXPEDICAO_POR_LOTE || '0',
            OP_VENDA_MAPEAR_LOTE: data[0].OP_VENDA_MAPEAR_LOTE || '0'
          }
        }
      } catch (err) {
        console.error('Erro ao carregar configurações:', err)
        this.$root.$bvToast.toast('Erro ao carregar configurações', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    async salvar() {
      try {
        const { data } = await this.$http.post('/api/protected/parametro/update', {
          registro: this.registro
        })
        
        this.$root.$bvToast.toast(data.mensagem || 'Configurações salvas com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          autoHideDelay: 3000
        })
        
        this.fechar()
      } catch (err) {
        console.error('Erro ao salvar configurações:', err)
        this.$root.$bvToast.toast(err.response?.data || 'Erro ao salvar configurações', {
          title: 'Erro',
          variant: 'danger',
          autoHideDelay: 5000
        })
      }
    },
    onModalShown() {
      this.carregarDados()
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.opacity-75 {
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/modals/ModalConfiguracaoCompraVenda.vue